// extracted by mini-css-extract-plugin
module.exports = {"container":"IceCreamBuilder_container__2f4Ew"};